import { FC } from "react";
import { EnterpriseAuthImagePanel } from "./component/ImagePanel";
import { EnterpriseAuthContainer } from "./component/EnterpriseAuthContainer";
import { AuthHeader } from "./component/AuthHeader";
import { AuthAlternative } from "./component/AuthAlternative";
import { useFormik } from "formik";
import { emptySignupFormValue, signUpSchema } from "./validation";
import { useNavigate } from "react-router-dom";
import InputField from "./component/EnterpriseInputField";
import PasswordInput from "./component/EnterprisePasswordInput";
import Button from "./component/EnterpriseButton";
import PasswordStrengthChecker from "./component/passwordChecker/PasswordStrengthChecker";

export const SignupPage: FC = () => {
  const navigate = useNavigate();

  const {
    errors,
    handleChange,
    handleBlur,
    values,
    touched,
    handleSubmit,
    isValid,
    dirty,
  } = useFormik({
    initialValues: emptySignupFormValue,
    validationSchema: signUpSchema,
    onSubmit: (values) => {
      if (values.password !== values.confirmPassword) return;
      navigate("/enterprise/work-name", {
        state: {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          password: values.password,
        },
      });
    },
  });

  const isButtonDisabled =
    !isValid ||
    !dirty ||
    !values.confirmPassword ||
    values.password !== values.confirmPassword;

  return (
    <div className="flex h-screen flex-col md:flex-row">
      <EnterpriseAuthContainer>
        <>
          <AuthHeader
            title="Sign Up"
            subtitle="Create an account to get started"
          />
          <form className="" onSubmit={handleSubmit}>
            <div className="flex flex-col lg:flex-row lg:gap-4">
              <InputField
                name="firstName"
                placeholder="e.g John"
                label="First Name"
                error={(touched?.firstName && errors?.firstName) || ""}
                value={values.firstName}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <InputField
                name="lastName"
                placeholder="e.g Doe"
                label="Last Name"
                error={(touched?.lastName && errors?.lastName) || ""}
                value={values.lastName}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <InputField
              name="email"
              placeholder="e.g johndoe@example.com"
              label="Email"
              error={(touched?.email && errors?.email) || ""}
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <PasswordInput
              name="password"
              label="Password"
              placeholder="••••••••••••"
              error={(touched?.password && errors?.password) || ""}
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {values.password.length > 0 && (
              <PasswordStrengthChecker password={values.password} />
            )}
            <PasswordInput
              name="confirmPassword"
              label="Confirm Password"
              placeholder="••••••••••••"
              value={values.confirmPassword}
              onChange={handleChange}
              onBlur={handleBlur}
              error={
                touched.confirmPassword &&
                values.password.length > 0 &&
                values.confirmPassword.length > 0
                  ? errors.confirmPassword
                  : undefined
              }
            />

            <Button
              text="Sign Up"
              className="w-full mt-6"
              type={isButtonDisabled ? "muted" : "primary"}
              disabled={isButtonDisabled}
            />
          </form>
          <AuthAlternative
            description="Already have an account?"
            buttonText=" Sign In"
            buttonLink="/enterprise/signin"
            googleButtonText="Sign up with Google"
          />
        </>
      </EnterpriseAuthContainer>

      <EnterpriseAuthImagePanel />
    </div>
  );
};
